var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRsvpNotGoing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10l-.0646-.0002C6.4451 21.965 2 17.4984 2 12zm9.7934 7.9974a8.3469 8.3469 0 00.429-.0004c1.7637-.0484 3.3819-.6696 4.6776-1.687l-4.9-4.9-4.9 4.9c1.2996 1.0204 2.9236 1.6424 4.6934 1.6874zM13.41 12l4.9 4.9c1.0186-1.2973 1.6401-2.9177 1.6871-4.6839a8.1666 8.1666 0 00-.0003-.4452c-.0497-1.7611-.6707-3.3768-1.6868-4.6709l-4.9 4.9zm-1.255-7.9985c1.7899.0341 3.4328.6582 4.745 1.6885l-4.9 4.9-4.9-4.9C8.45 4.63 10.15 4 12 4c.0518 0 .1035.0005.155.0015zM10.59 12l-4.9 4.9c-1.0282-1.3094-1.6518-2.9482-1.6883-4.7337A8.21 8.21 0 014 12c0-1.85.63-3.55 1.69-4.9l4.9 4.9z",
    fill: "#CC2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRsvpNotGoing);
export default __webpack_public_path__ + "static/media/Icon-RSVP-Not-Going.2403ed69188b51459aad31b318fa4e8c.svg";
export { ForwardRef as ReactComponent };